module.exports = __webpack_public_path__ + "img/ground.7b832916.svg";